// HelpSearchBar — fuzzy-match over the in-memory topic list.
//
// Client-side filter; the /api/help/topics response is small (~10 rows)
// so we avoid a round-trip per keystroke. Spec §test-matrix #2 —
// "typing 'refund' narrows to 1 card".

import { Search, X } from 'lucide-react'

interface HelpSearchBarProps {
  value: string
  onChange: (v: string) => void
  placeholder?: string
  autoFocus?: boolean
}

export function HelpSearchBar({
  value,
  onChange,
  placeholder = 'Search help topics — e.g. "refund", "kiosk", "e-ticket"',
  autoFocus = false,
}: HelpSearchBarProps) {
  return (
    <label className="relative block w-full max-w-xl">
      <span className="sr-only">Search help topics</span>
      <Search
        aria-hidden="true"
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-soft"
      />
      <input
        type="search"
        role="searchbox"
        data-testid="help-search"
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-hairline bg-surface-raised py-2.5 pl-9 pr-9 text-sm text-ink placeholder:text-ink-soft focus:border-butler-500 focus:outline-none focus:ring-2 focus:ring-butler-500/30 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-ink-soft hover:bg-surface-page hover:text-ink"
        >
          <X aria-hidden="true" className="h-3.5 w-3.5" />
        </button>
      )}
    </label>
  )
}
